import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy URL — the page moved to /kontakt. Permanent redirect keeps old links
// and search-engine index entries working.
export const Route = createFileRoute('/obsah/kontakt')({
  beforeLoad: ({ location }) => {
    // The query string carries the campaign parameters of old links.
    throw redirect({ href: `/kontakt${location.searchStr}`, statusCode: 301 })
  },
})
